import React from 'react';
import clsx from 'clsx';
import { EOperationStatus, IOperation } from 'types';
import { Icons } from 'components';

import './style.scss';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface ISearchInputProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    searchOperation: IOperation;
    inputValue: string;
    onCloseButtonClick: () => any;
    onSearchInputChange: (value: string) => any;
    /* Для мобильной версии */
    onInputClick?: () => void;
}

export const SearchInput: React.FC<ISearchInputProps> = (props): JSX.Element => {
    const {
        searchOperation,
        className,
        inputValue,
        onCloseButtonClick,
        onSearchInputChange,
        onInputClick,
        ...restDivProps
    } = props;

    const { t } = useTranslation();
    const inputRef = React.createRef<HTMLInputElement>();
    React.useEffect(() => {
        inputRef.current?.focus();
        onInputClick?.();
    }, []);

    return (
        <div
            className={clsx('oms-search-input', className)}
            {...restDivProps}
        >
            <div className="input-wrapper">
                <input
                    className="oms-search-input__input"
                    type="text"
                    placeholder={t('Поиск')}
                    value={inputValue}
                    autoComplete="off"
                    disabled={searchOperation?.status === EOperationStatus.PENDING}
                    readOnly={searchOperation?.status === EOperationStatus.PENDING}
                    ref={inputRef}
                    onChange={(e) => {
                        let { value } = e.currentTarget;
                        props.onSearchInputChange(value);
                    }}
                    onClick={() => {
                        onInputClick?.();
                    }}
                />
            </div>
            <div
                className={clsx('close-button-wrapper', {
                    'disabled': searchOperation?.status === EOperationStatus.PENDING
                })}
                onClick={props.onCloseButtonClick}
            >
                <Icons.IconClose />
            </div>
        </div>
    );
};
